class Details {
  constructor(data) {
    this.email = data?.email;
    this.message = data?.message;
  }
}

export default Details;
